export const MP_UI_TOPBAR_HEIGHT = 71; // topbar + separator
export const APP_CONTAINER_WIDTH = 1080;
export const APP_CONTAINER_WIDE_WIDTH = 1170;
export const APP_CONTAINER_SELECTOR = 'main';
export const APP_CONTAINER_SELECTOR_FRAMEWORK = '#mpui-fw-main-section';
